import React from 'react';

import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const UserResetSettingsSkeleton = () => (
    <Group direction="v" alignItems="start">
        <CheckboxSkeleton labelWidth={300}/>
        <FormItemSkeleton labelWidth={100}>
            <SkeletonItem height={32} width={300}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={100}>
            <SkeletonItem height={32} width={300}/>
        </FormItemSkeleton>
    </Group>
);
